import { formHelperTextLocale as formHelperText } from '../FormHelperText/FormHelperText.locale';
import { formLabelLocale as formLabel } from '../FormLabel/FormLabel.locale';
import { searchLocale as search } from '../Search/Search.locale';
import { sliderLocale as slider } from '../Slider/Slider.locale';
import { paginationLocale as pagination } from '../Pagination/Pagination.locale';
import { datePickerLocale as datePicker } from '../DatePicker/DatePicker.locale';
import { popoverLocale as popover } from '../Popover/Popover.locale';
import { tagLocale as tag } from '../Tag/Tag.locale';
export const en_US = {
    formHelperText,
    formLabel,
    search,
    slider,
    pagination,
    datePicker,
    popover,
    tag,
};
//# sourceMappingURL=en_US.js.map